import React from "react";

export const RtlProvider = ({ children }: any) => {
  return (
    <div dir='rtl'>{children}</div>
  );
};
